import React, { useState } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Alert, Button, Checkbox, Form, Input, Typography } from "antd";
import { useTranslation } from "react-i18next";
import accountsApi from "../../api/Accounts/AccountsApi";
import { useNavigate } from "react-router-dom";

const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const onFinish = (values: any) => {
    accountsApi
      .login(values.username, values.password)
      .then((values: any) => {
        navigate("/");
      })
      .catch((err) => {
        setLoginError("error");
      });
  };

  const [loginError, setLoginError] = useState("");

  return (
    // LoginLayout centres this form on the page. 300px (rather than the old
    // 260px) gives "Remember me" and "Forgot password" room to share one line.
    <Form
      name="normal_login"
      className="login-form"
      initialValues={{ remember: true }}
      onFinish={onFinish}
      style={{ width: 300 }}
    >
      {/* Same heading treatment as the forgot/reset screens. No helper text
          here on purpose: a login form explains itself, whereas the reset
          screen has to say what actually arrives in your inbox. */}
      <Typography.Title level={4} style={{ marginTop: 0 }}>
        {t("Log in")}
      </Typography.Title>
      <Form.Item
        name="username"
        rules={[{ required: true, message: t("Please input your Username!") }]}
      >
        <Input
          prefix={<UserOutlined className="site-form-item-icon" />}
          placeholder={t("Username")}
        />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[{ required: true, message: t("Please input your Password!") }]}
      >
        <Input
          prefix={<LockOutlined className="site-form-item-icon" />}
          type="password"
          placeholder={t("Password")}
        />
      </Form.Item>
      <Form.Item>
        {/* One row: the checkbox and the link were stacking because they could
            not both fit the old 260px width. */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Form.Item name="remember" valuePropName="checked" noStyle>
            <Checkbox>{t("Remember me")}</Checkbox>
          </Form.Item>

          <Button
            className="login-form-forgot"
            type="link"
            style={{ padding: 0 }}
            onClick={() => navigate("/forgot-password")}
          >
            {t("Forgot password")}
          </Button>
        </div>
      </Form.Item>
      {/* Wrapped in a Form.Item so it picks up the same bottom margin as every
          other row; a bare Alert had none and sat flush against the button. */}
      {loginError ? (
        <Form.Item>
          <Alert type="error" message={t("Email or Password incorrect")} />
        </Form.Item>
      ) : null}
      <Form.Item>
        <Button type="primary" htmlType="submit" className="login-form-button">
          {t("Log in")}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default LoginPage;
